<template>
  <div class="boxstyle px-5 py-5">
    <div v-for="(track, index) in orderDetailsData" :key="index" class="status-item">
      <feather-icon
        :icon="getIcon(track.status)"
        :class="getStatusClass(track.status)"
        svgClasses="w-5 h-5"
      />
      <span :class="index === orderDetailsData.length - 1 ? 'noLine' : 'line'"></span>
      <span
        class="status-text"
        :class="{
          bold: track.status === 'In Progress' || track.status === 'Complete',
        }"
      >
        {{ track.label }} -
        <span :class="getStatusClass(track.status)">{{ track.status }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderDetailsData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getIcon(status) {
      if (status === "Complete") return "CheckCircleIcon";
      if (status === "In Progress") return "ArrowUpCircleIcon";
      return "ClockIcon";
    },
    getStatusClass(status) {
      if (status === "Complete") return "complete-icon";
      if (status === "In Progress") return "inprogress-icon";
      return "pending-icon";
    },
  },
};
</script>

<style scoped>
.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.status-text {
  margin-left: 28px;
}
.bold {
  font-weight: bold;
}
.noLine {
  position: relative;
  left: 1%;
  margin-left: -20px;
  margin-top: 31px;
  margin-bottom: -23px;
}
.line {
  border-left: 2px dashed #23c023;
  height: 35px; /* Adjust to control line length */
  position: relative;
  left: 1%;
  margin-left: -20px;
  margin-top: 31px;
  margin-bottom: -23px;
}

.complete-icon {
  color: green;
}

.inprogress-icon {
  color: blue;
}

.pending-icon {
  color: orange;
}
</style>
